import { render } from "./ChangePercorso.vue?vue&type=template&id=654ca58b&scoped=true&ts=true"
import script from "./ChangePercorso.vue?vue&type=script&lang=ts"
export * from "./ChangePercorso.vue?vue&type=script&lang=ts"

import "./ChangePercorso.vue?vue&type=style&index=0&id=654ca58b&scoped=true&lang=css"

import exportComponent from "E:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654ca58b"]])

export default __exports__